import React, { createContext, useContext, useState, useCallback } from 'react';

/**
 * Context global para manejar el estado de "backend is working"
 * Propósito: señal visual reutilizable para CUALQUIER operación larga de backend
 * Ejemplos: "recortando PDF…", "procesando documento…", "generando respuesta…"
 */
interface LoadingContextValue {
  isGlobalLoading: boolean;
  startLoading: () => void;
  stopLoading: () => void;
}

const LoadingContext = createContext<LoadingContextValue | null>(null);

export function LoadingProvider({ children }: { children: React.ReactNode }) {
  const [loadingCount, setLoadingCount] = useState(0);

  const startLoading = useCallback(() => {
    setLoadingCount((c) => c + 1);
  }, []);

  const stopLoading = useCallback(() => {
    setLoadingCount((c) => Math.max(0, c - 1));
  }, []);

  const value: LoadingContextValue = {
    isGlobalLoading: loadingCount > 0,
    startLoading,
    stopLoading,
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
}

export function useGlobalLoading() {
  const ctx = useContext(LoadingContext);
  if (!ctx) {
    throw new Error('useGlobalLoading must be used inside <LoadingProvider />');
  }
  return ctx;
}
